import { ProfileService } from "src/app/core/services/profile.service";
import { Component, OnInit, Input, ViewChild, ElementRef, HostListener, OnDestroy } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { AuthService } from "../../../core/services/auth.service";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { BusinessFieldModalComponent } from "src/app/components/auth/on-boarding/business-field-modal/business-field-modal.component";
import { DatePipe } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { LITERALS } from "src/app/core/constants/literals.constant";
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { RequestVarificationComponent } from '../../../shared/modals/interests/request-varification/request-varification.component';
import { RequestSentComponent } from '../../settings/request-sent/request-sent.component';
import { MyInterestService } from 'src/app/core/services/my-interest.service';
import { environment } from 'src/environments/environment';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { PublicationPreviewWrapperComponent } from '../../material-detail/publication-preview-wrapper/publication-preview-wrapper.component';
import { WebsocketService } from 'src/app/core/services/websocket.service';
import { ChatService } from 'src/app/core/services/chat.service';
import { Subscription } from 'rxjs';

declare var OneSignal: any;
declare let fbq: Function;

@Component({
  selector: "app-on-boarding",
  templateUrl: "./on-boarding.component.html",
  styleUrls: ["./on-boarding.component.scss"]
})
export class OnBoardingComponent implements OnInit, OnDestroy {

  @Input() public confirmation_token;
  @Input() profileURL;

  @ViewChild('photo_id_proof', { static: true }) verificationPhoto: ElementRef;
  @ViewChild('angularMultiselect', { static: false }) angularMultiselect: any;
  authToken: any;

  onboard: any = "selectUser";
  userType: any = "first";
  user: any = "individual";
  currentuser: any;

  imagePath: any;
  imgURL: any;
  file: File;
  isImageError: boolean = false;
  isImageSizeError: boolean = false;
  isConfirmed: boolean = false;

  onboardProfileForm: FormGroup;
  submitted: boolean = false;
  minDate: any;

  cityList: any;
  selectedCity: any = [];
  dropdownSettings: any;

  userCategories: any;
  indusryTypes: any;

  myInterest = [];
  isError: boolean = false;
  errorMessage: string;
  taggedInterestOfUser: any;
  myInterestTaggedData: any[];
  selectedInterestId = [];
  deSelectedInterestId = [];
  selectedInterest = [];
  onboardBusinessProfileForm: FormGroup;
  businessType: any;
  allfield = true;
  isGSTSubmitted: boolean = false;
  isSubmitted: boolean = false;
  businessData: any;
  currentFlow: any;
  requestVerificationForm: FormGroup;
  submittedRequestVerification: boolean = false;
  imgURLRequestVerification: any = '';
  message: string;
  isImageErrorRequestVerification: boolean = false;
  imagePathRequestVerification; any;
  showPreviewRequestVerification: boolean;
  isImagePreviewRequestVerification = false;
  fileRequestVerification: File;
  verification_proof_type: any = '';
  publicationUploadType = [
    'docx',
    'pdf',
    'png',
    'jpg',
    'jpeg',
  ];
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    autoWidth: true,
    navSpeed: 500,
    // margin: 20,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      },
      1199: {
        items: 1
      }
    },
    nav: true
  }
  myInterestParent = [];
  interestInOneSlide = 19;
  windowWidth = 0;
  fileSizeError: boolean = false;
  verificationTypes: any;
  selectedType: any;
  userObj = {
    id: '',
    name: '',
    username: '',
    email: '',
    author: {}
  };
  isSvgImageError: boolean = false;
  imageErrorMsg: string = LITERALS.VALIDATION.IMAGE_VALIDATION;
  cityListSubscriber: Subscription;

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    public datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private router: Router,
    private _profileService: ProfileService,
    private _myInterest: MyInterestService,
    private chatService: ChatService
  ) {
    this.windowWidth = window.innerWidth;
  }

  ngOnInit() {

    this.dropdownSettings = {
      singleSelection: true,
      text: "Your Country",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      noDataLabel: "No countries found",
      classes: "form-control",
      labelKey: "name"
    };

    if (this.profileURL) {
      this.imgURL = this.profileURL;
    }

    this.myInterests();
    this.loadBusinessType();
    this.loadIndustries();
  }

  goNext(page) {
    this.submitted = false;
    this.minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 18));

    if (page == "individual" && this.currentFlow != page) {
      this.onboardProfileForm = this.formBuilder.group({
        user_category_id: ["", [Validators.required]],
        birth_date: ["", Validators.compose([Validators.required])],
        locations_attributes: this.formBuilder.group({
          city: [""]
        }),
        status: ["", [Validators.required]]
      });
    } else if (page == "business" && this.currentFlow != page) {
      this.onboardProfileForm = this.formBuilder.group({
        name: ["", Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.BUISNESS_NAME_PATTERN), this.noWhitespaceValidator, Validators.maxLength(45)])],
        industry_id: ["", [Validators.required]],
        locations_attributes: this.formBuilder.group({
          city: [""]
        }),
        status: ["", [Validators.required]]
      });
      this.requestVerificationForm = this.formBuilder.group({
        name: ["", Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.BUISNESS_NAME_PATTERN), this.noWhitespaceValidator])],
        known_as: ["", Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.BUISNESS_NAME_PATTERN), this.noWhitespaceValidator])],
        verification_proof_type_id: ['', Validators.required],
      });
    }

    this.loadIndustries();
    this.loadUserCategories();

    this.onboard = page;
    this.currentFlow = page;
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  closeDialog() {
    this.activeModal.close();
  }

  loadIndustries() {
    this._profileService.loadIndustryType().subscribe(
      (response: any) => {
        if (response.success) {
          this.indusryTypes = response.data.industry;
        }
      });
  }

  getVerificationTypes() {
    this._profileService.fetchVerificationTypes(this.user).subscribe(
      (response: any) => {
        if (response.success) {
          this.verificationTypes = response.data.verification_proofs
        }
      });
  }

  onChangeType(typeID) {
    this.verificationTypes.forEach(element => {
      if (element.id == typeID)
        this.selectedType = element;
    });
  }

  loadUserCategories() {
    this.spinner.show();
    this._profileService.loadUserCategory().subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          this.userCategories = response.data.user_category;
        }
      });
  }

  preview(files, event) {
    this.isImageError = false;
    this.isImageSizeError = false;
    this.isSvgImageError = false;
    if (files.length === 0) return;

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.isImageError = true;
      return;
    }

    if (mimeType !== 'image/png' && mimeType !== 'image/jpeg' && mimeType !== 'image/gif') {
      this.isSvgImageError = true;
      return;
    }

    if (files[0].size >= 5242880) {
      event.target.value = '';
      this.isImageSizeError = true;
      return;
    }
    var reader = new FileReader();
    this.imagePath = files;
    this.file = files[0];
    reader.readAsDataURL(files[0]);
    reader.onload = _event => {
      this.imgURL = reader.result;
    };
    this.isImageError = false;
    this.isImageSizeError = false;
  }

  filesDropped(files) {
    if (files[0].file.length === 0)
      return;

    var mimeType = files[0].file.type;
    if (mimeType.match(/image\/*/) == null) {
      this.isImageError = true;
      return;
    }

    var reader = new FileReader();
    this.file = files[0].file;
    reader.readAsDataURL(files[0].file);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    }
    this.isImageError = false;
  }

  getCitiesList(event) {
    if (event.target.value && event.target.value.length > 2) {
      if (this.cityListSubscriber) {
        this.cityListSubscriber.unsubscribe();
      }
      this.cityList = [];
      this.cityListSubscriber = this._profileService.getCountries(event.target.value).subscribe(
        (response: any) => {
          if (response.success && response.data.countries) {
            this.cityList = response.data.countries;
          }
        });
    }
  }

  clearData(e) {
    if (this.angularMultiselect && !this.angularMultiselect.filter) {
      this.cityList = [];
    }
  }

  onItemSelect(item: any) {
    this.selectedCity = item;
  }

  onItemDeSelect(item: any) {
    this.selectedCity = [];
  }

  onSubmit() {
    this.submitted = true;
    if (this.onboardProfileForm.invalid) {
      return;
    }
    let params;
    if (this.onboard == "individual") {
      if (this.selectedCity) {
        params = {
          user: {
            user_category_id: this.onboardProfileForm.value.user_category_id,
            status: this.onboardProfileForm.value.status,
            birth_date: this.onboardProfileForm.value.birth_date,
            locations_attributes: [
              {
                country: this.selectedCity.name
              }
            ]
          }
        };
      } else {
        params = {
          user: {
            user_category_id: this.onboardProfileForm.value.user_category_id,
            status: this.onboardProfileForm.value.status,
            birth_date: this.onboardProfileForm.value.birth_date
          }
        };
      }

      params.user.birth_date = this.datePipe.transform(
        params.user.birth_date,
        "dd/MM/yyyy"
      );
    }
    else if (this.onboard == "business") {
      if (this.selectedCity) {
        params = {
          user: {
            status: this.onboardProfileForm.value.status,
            locations_attributes: [
              {
                country: this.selectedCity.name
              }
            ]
          },
          user_business: {
            name: this.onboardProfileForm.value.name.trim(),
            industry_id: this.onboardProfileForm.value.industry_id,
          }
        };
      } else {
        params = {
          user: {
            status: this.onboardProfileForm.value.status,
          },
          user_business: {
            name: this.onboardProfileForm.value.name.trim(),
            industry_id: this.onboardProfileForm.value.industry_id,
          }
        };
      }
    }

    if (this.file) {
      params.user["avatar"] = this.file;
    }

    params.user.user_type = this.onboard;

    if (this.onboard == 'business') {
      this.submitted = false;
      this.onboard = 'businessRequestVerification';
      this.businessData = params;
    }
    else
      this.proceedToEdit(params);

  }

  proceedToEdit(params, verificationData?) {
    // console.log(this.confirmation_token);
    // if (!this.isConfirmed) {
    //   this.spinner.show();
    //   this.authService.confirmUser(this.confirmation_token).subscribe(
    //     (response: any) => {
    //       console.log('this is calling-');
    //       if (response.body.success) {
    //         this.isConfirmed = true;
    //         const token = response.headers.get("Authorization");
    //         response.body.data["token"] = token;
    //         this.authToken = token;
    //         this.currentuser = response.body.data;
    //         this.redirectUser(this.currentuser);

    //         this.onNext();

    //         if (verificationData) {
    //           this.editUser(params, true, verificationData);
    //         }
    //         else {
    //           this.editUser(params);
    //         }
    //       }
    //       else {
    //         if (response.body.status == 422) {
    //           this.spinner.hide();
    //           const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
    //           modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.USER_ALREADY_CONFIREMED;
    //         }
    //       }
    //     },
    //     (error: any) => {
    //       this.spinner.hide();
    //     }
    //   );
    // } else {
    //   this.editUser(params);
    // }

    

    if (verificationData) {
      this.editUser(params, true, verificationData);
    }
    else {
      this.editUser(params);
    }
  }

  redirectUser(currentUser) {
    localStorage.setItem("currentUser", JSON.stringify(currentUser));
    localStorage.setItem("rememberMe", "true");
  }

  editUser(userData, isBusinessUser?, verificationData?) {
    this.spinner.show();
    userData.user.confirmation_token = this.confirmation_token;
    this.authService.confirmAndEditUserProfile( userData, this.onboard).subscribe(
      (response: any) => {
        if (response.body.success) {
          
          this.isConfirmed = true;
            const token = response.headers.get("Authorization");
            response.body.data["token"] = token;
            this.authToken = token;
            this.currentuser = response.body.data;
            this.redirectUser(this.currentuser);

          const userData = this.currentuser.user;
          this.userObj.id = userData['chat_sku'];
          this.userObj.name = userData['name'];
          this.userObj.username = userData['chat_sku'];
          this.userObj.email = userData['email'];
          this.userObj.author = {
            id: userData['chat_sku'],
            name: userData['name'],
            username: userData['chat_sku'],
            email: userData['email']
          };
          this.onNext();
          this.chatService.connectToSocket(this.userObj);
          OneSignal.push(() => {
            OneSignal.init({
              appId: environment.oneSignal_appId,
            });
          });

          if (isBusinessUser) {
            this.verifyBusinessUser(verificationData);
          }
          else {
            const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            modalRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.ACCOUNT_CREATED_SUCCESSFULLY;
            this.router.navigate(["/dashboard"]).then(() => {
              this.activeModal.close();
              this.spinner.hide();
            });
            fbq('track', 'CompleteRegistration');
          }
        } else {
          this.spinner.hide();
        }
      }, (error: any) => {
        this.spinner.hide();
      });
  }

  verifyBusinessUser(verifyUserData) {
    this.spinner.show();
    this.authService.verificationOfUser(verifyUserData).subscribe(
      (response: any) => {
        if (response.success) {
          const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modalRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.ACCOUNT_CREATED_SUCCESSFULLY;
          if (this.fileRequestVerification) {
            this.closeDialog();
            this.modalService.open(RequestSentComponent,
              {
                centered: true, backdrop: 'static', keyboard: false
              });
          }
          this.closeDialog();
          this.router.navigate(["/dashboard"]).then(() => {
            this.closeDialog();
            this.spinner.hide();
          });
          fbq('track', 'CompleteRegistration');
        } else {
          this.spinner.hide();
        }
      },
      (error: any) => {
        this.spinner.hide();
      }
    );
  }

  setMyInterestParent() {
    const slides = Math.ceil(this.myInterest.length / this.interestInOneSlide);
    for (var i = 0; i < slides; i++) {
      this.myInterestParent[i] = this.myInterest.slice((i * this.interestInOneSlide), (i * this.interestInOneSlide) + this.interestInOneSlide)
    }
  }

  myInterests() {
    this._myInterest.getMyInterest().subscribe((response: any) => {
      if (response.success) {
        this.myInterest = response.data.interests;
        this.setMyInterestParent()
      }
    }, (error: any) => {
      this.spinner.hide();
    });
  }

  selectedInterestIdOfUser() {
    this.spinner.show();
    this._myInterest.getTaggedInterestOfUser().subscribe((response: any) => {
      if (response.success) {
        this.spinner.hide();
        this.taggedInterestOfUser = response.data.tagged_interests;
        this.myInterest.map((val) => {
          val.isTagged = false;
        });

        this.myInterest.forEach(element => {
          if (response.data.tagged_interests.indexOf(element.id) > -1) {
            element.isTagged = true;
          }
        });

        this.myInterestTaggedData = this.myInterest.filter((val) => {
          return val.isTagged === true;
        });
      }
    })
  }

  onNext() {

    this.selectedInterestId = this.myInterest.filter(interest => {
      return interest.isTagged == true;
    }).map((val) => {
      return val.id;
    })
    this.deSelectedInterestId = this.myInterest.filter(deSelectedInterest => {
      return deSelectedInterest.isTagged == false
    }).map((val) => {
      return val.id;
    });

    const taggedInterest = {
      tagged_interest: {
        selected_interest_ids: this.selectedInterestId,
        deselected_interest_ids: this.deSelectedInterestId
      }
    };

    this.spinner.show();
    this._myInterest.createTaggedInterestToUser(taggedInterest).subscribe(
      (response: any) => {
      });
  }

  toggleInterest(interestList) {
    interestList.isTagged = !interestList.isTagged

    this.selectedInterest = this.myInterest.filter(interest => {
      return interest.isTagged == true;
    })
  }

  /**
   * Load business type
   *
   * @memberof OnBoardingComponent
   */
  loadBusinessType() {
    this._profileService.loadBusinessType().subscribe(
      (response: any) => {
        if (response.success) {
          this.businessType = response.data.business;
        }
      });
  }

  goToStep2OfBusinessForm(isSkipped) {
    if (!isSkipped) {
      this.isGSTSubmitted = true;
      if (this.onboardBusinessProfileForm.controls.verification_proof_no.invalid) {
        return;
      }
    }
    this.toggleContent();
  }

  toggleContent() {
    this.allfield = !this.allfield;
  }

  /**
   * Go to request verification page
   *
   * @returns
   * @memberof OnBoardingComponent
   */
  gotoRequestVerification() {
    this.isSubmitted = true;

    if (this.onboardBusinessProfileForm.controls.business_id.invalid || this.onboardBusinessProfileForm.controls.business_address.invalid) {
      return;
    }

    this.businessData = {
      ...this.businessData,
      user_business: {
        ...this.businessData.user_business,
        ...this.onboardBusinessProfileForm.value
      }
    }
    this.businessData.user_business.business_address = this.businessData.user_business.business_address.trim();
    this.onboard = 'businessRequestVerification';
    this.isSubmitted = false;

  }

  /**
   * Submit request verification form
   *
   * @returns
   * @memberof OnBoardingComponent
   */
  onSubmitRequestVerification() {
    this.submittedRequestVerification = true;
    if (this.requestVerificationForm.invalid || this.imgURLRequestVerification == '' || (this.selectedType.name == 'Other' && this.verification_proof_type == '') || this.fileSizeError || this.isImageErrorRequestVerification) {
      return;
    }

    let params;
    params = {
      verification: {
        ...this.requestVerificationForm.value,
      }
    }
    if (this.fileRequestVerification)
      params.verification.photo_id_proof = this.fileRequestVerification;

    if (this.selectedType.name == 'Other') {
      params.verification.other_proof_type = this.verification_proof_type;
    }

    this.submittedRequestVerification = false;

    if (this.requestVerificationForm.value.verification_proof_no)
      this.businessData.user_business.verification_proof_no = this.requestVerificationForm.value.verification_proof_no.trim();

    this.proceedToEdit(this.businessData, { verificationData: params });
  }

  skipAndContinue() {
    this.proceedToEdit(this.businessData);
  }

  removeFile() {
    this.showPreviewRequestVerification = false;
    this.imgURLRequestVerification = '';
  }

  openConfirmModal() {
    this.closeDialog();
    this.modalService.open(RequestSentComponent, { centered: true });
  }

  /**
   * Preview request verification form image
   *
   * @param {*} files
   * @returns
   * @memberof OnBoardingComponent
   */

  filesDroppedRequestVerification(files) {
    const FileObj = files[0].file;
    this.previewrequestVerification({ 0: FileObj });
  }

  previewrequestVerification(files) {

    if (files.length === 0)
      return;

    let mineType = files[0].type;

    var reader = new FileReader();
    reader.readAsDataURL(files[0]);

    this.isImagePreviewRequestVerification = false;
    this.isImageErrorRequestVerification = false;
    this.fileSizeError = false;

    var fileName = files[0].name.split('.');
    const extension = fileName[fileName.length - 1];

    if ((!mineType.match(/image\/*/)) && (!mineType.match(/pdf\/*/)) && (!mineType.match(/document\/*/)) || (mineType.match(/svg\/*/))) {
      this.isImageErrorRequestVerification = true;
      return;
    }

    if (files[0].size / 1048576 > 4.999) {
      this.fileSizeError = true;
      return;
    }

    reader.onload = (_event) => {
      if (mineType.match(/image\/*/)) {
        this.isImagePreviewRequestVerification = true;
      }
      this.showPreviewRequestVerification = true;
      this.imgURLRequestVerification = reader.result;
      this.fileRequestVerification = files[0];
    }
    this.isImageErrorRequestVerification = false;
    this.fileSizeError = false;
  }

  filePreview() {
    const modelRef = this.modalService.open(PublicationPreviewWrapperComponent, { centered: true, size: "lg", windowClass: 'pdf-modal' });
    modelRef.componentInstance.url = this.imgURLRequestVerification;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowWidth = event.target.innerWidth;
  }

  restrictNumeric(event) {
    //firefox solution
    event = event || window.event;
    var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
    var charStr = String.fromCharCode(charCode);

    if (!charStr.match(/^[0-9/]+$/))
      event.preventDefault();
    const restrictKeycodes = [101, 46, 43, 45];
    if (restrictKeycodes.includes(event.keyCode) || event.target.value.length > 11) {
      return false;
    }
  }

  restrictNumericPaste(event) {
    let text = event.clipboardData.getData('text').toString();
    let filteredText = text.replace(REGEX_PATTERNS.NUMBER_REMOVE_DATE, "");
    // this.editProfileForm.controls.birth_date.setValue(filteredText);
    event.target.value = filteredText;
    event.preventDefault();
  }

  ngOnDestroy() {
    if (this.cityListSubscriber) {
      this.cityListSubscriber.unsubscribe();
    }
  }
}

